import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import React from 'react';

/**
 * @typedef {import('@material-ui/core').SelectProps} SelectProps
 */

/**
 * @typedef {object} SelectFilterProps
 * @prop {import('../interfaces').TableFilterComponentOption[]} props.options
 */

/**
 * @param {SelectProps & SelectFilterProps} props
 */
export default function SelectFilter(props) {
  const options = props?.options || [];

  return (
    <FormControl
      variant="outlined"
      color="primary"
      size="small"
      fullWidth
    >
      <InputLabel>{props?.label}</InputLabel>
      <Select
        {...props}
        defaultValue={props?.defaultValue ? props.defaultValue : options[0]?.key}
      >
        {options.map(option => {
          return (
            <MenuItem value={option.key} title={option?.description}>
              {option.name}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  );
}